module.exports = __webpack_public_path__ + "img/media (14).0290085f.png";